var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31.995,
    viewBox: "0 0 32 31.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4dcabd;}.b{fill:#45afa2;}.c{fill:#d7fffa;}.d{fill:#97f6ed;}.e{fill:#218fb9;}.f{fill:#217fb5;}.g{fill:#c5fff7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32,16a16,16,0,1,0-16,16A16,16,0,0,0,32,16Zm0,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M78.059,55.57a16,16,0,0,1-22.48,22.477A16,16,0,1,0,78.059,55.57Zm0,0",
    transform: "translate(-52.104 -52.097)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M274.227,243.881q.369.051.749.07l.142.006.144,0h.144a8.5,8.5,0,0,0,4.551-1.311.748.748,0,0,0,.348-.632,4.9,4.9,0,0,0-4.9-4.9l-.14,0-.124.005-.06,0c-.037,0-.074,0-.111.008s-.1.009-.142.015a4.88,4.88,0,0,0-2.887,1.4c-.084.084-.164.171-.242.261Zm0,0",
    transform: "translate(-254.718 -222.301)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M317.453,238.56a4.9,4.9,0,0,0-4.6-1.3,4.9,4.9,0,0,1,3.765,4.764.747.747,0,0,1-.347.632,8.481,8.481,0,0,1-3.418,1.236,8.6,8.6,0,0,0,1.133.076,8.5,8.5,0,0,0,4.551-1.311.747.747,0,0,0,.347-.632A4.877,4.877,0,0,0,317.453,238.56Zm0,0",
    transform: "translate(-293.302 -222.305)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M294.154,155.564a2.631,2.631,0,1,0-2.632,2.631A2.631,2.631,0,0,0,294.154,155.564Zm0,0",
    transform: "translate(-270.835 -143.375)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M302.585,154.074a2.631,2.631,0,0,1-2.542,4.343,2.631,2.631,0,1,0,2.542-4.343Zm0,0",
    transform: "translate(-281.29 -144.444)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M115.728,248.742a1,1,0,0,1-.464.845,11.434,11.434,0,0,1-12.167,0,1,1,0,0,1-.464-.845,6.548,6.548,0,0,1,13.1,0Zm0,0",
    transform: "translate(-96.218 -227.058)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M183.149,244.114a6.557,6.557,0,0,0-6.556-1.631,6.553,6.553,0,0,1,4.624,6.259,1,1,0,0,1-.464.845,11.338,11.338,0,0,1-4.159,1.591,11.522,11.522,0,0,0,1.925.162,11.363,11.363,0,0,0,6.084-1.753,1,1,0,0,0,.464-.845A6.521,6.521,0,0,0,183.149,244.114Zm0,0",
    transform: "translate(-165.556 -227.058)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M158.153,133.166a3.518,3.518,0,1,0-3.518,3.517A3.517,3.517,0,0,0,158.153,133.166Zm0,0",
    transform: "translate(-141.673 -121.546)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M167.442,133.16a3.518,3.518,0,0,1-3.97,5.5,3.517,3.517,0,1,0,3.97-5.5Zm0,0",
    transform: "translate(-153.255 -124.838)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUsers);
export default __webpack_public_path__ + "static/media/active-users.99e27aa9820a1bae09bc2339e8a85dc7.svg";
export { ForwardRef as ReactComponent };